export const getMonth=(month:any)=>{
    let mes=month
    
    if(month=="Jan"){
      mes="Enero"
    }

    if(month=="Feb"){
      mes="Febrero"
    }

    if(month=="Mar"){
      mes="Marzo"
    }

    if(month=="Apr" || month=="Abr"){
      mes="Abril"
    }

    if(month=="May"){
      mes="Mayo"
    }

    if(month=="Jun"){
      mes="Junio"
    }

    if(month=="Jul"){
      mes="Julio"
    }

    if(month=="Aug" || month=="Ago"){
      mes="Agosto"
    }

    if(month=="Sep"){
      mes="Septiembre"
    }

    if(month=="Oct"){
      mes="Octubre"
    }

    if(month=="Nov"){
      mes="Noviembre"
    }

    if(month=="Dec" || month=="Dic"){
      mes="Diciembre"
    }

    return mes
  }

export const getFecEntrega=(dias:any,fecha_:any)=>{
    let hoy:Date = new Date();
    let fecha_pago:Date=new Date(fecha_+" 00:00:00")
    
    let i:number=0;
    while (i<parseInt(dias)) { // 7 días habiles
      fecha_pago.setTime(fecha_pago.getTime()+24*60*60*1000); // añadimos 1 día
        if (fecha_pago.getDay() != 6 && hoy.getDay() != 0)
            i++;  
    }

    let fecha:any = fecha_pago.getDate()+ '/' + ((fecha_pago.getMonth())+1) + '/' + fecha_pago.getFullYear();
    let mes:any=((fecha_pago.getMonth())+1);
    mes=(mes.toString().length==1)?"0"+mes:mes;
    let dia:any=fecha_pago.getDate();
    dia=(dia.toString().length==1)?"0"+dia:dia;
    //return fecha_pago.getFullYear()+"-"+mes+"-"+dia
    return fecha_pago.getFullYear()+"-"+mes+"-"+dia
 }

 export const getFecEntrega_ddmmyyyy=(dias:any,fecha_:any)=>{
  let hoy:Date = new Date();
  let fecha_pago:Date=new Date(fecha_+" 00:00:00")
  
  let i:number=0;
  while (i<parseInt(dias)) { // 7 días habiles
    fecha_pago.setTime(fecha_pago.getTime()+24*60*60*1000); // añadimos 1 día
      if (fecha_pago.getDay() != 6 && hoy.getDay() != 0)
          i++;  
  }

  let fecha:any = fecha_pago.getDate()+ '/' + ((fecha_pago.getMonth())+1) + '/' + fecha_pago.getFullYear();
  let mes:any=((fecha_pago.getMonth())+1);
  mes=(mes.toString().length==1)?"0"+mes:mes;
  let dia:any=fecha_pago.getDate();
  dia=(dia.toString().length==1)?"0"+dia:dia;
  //return fecha_pago.getFullYear()+"-"+mes+"-"+dia
  return dia+"-"+mes+"-"+fecha_pago.getFullYear()
}

 export const getFecActual=()=>{
  let hoy = new Date();
  let i=0;
  let fecha = hoy.getDate()+ '/' + ((hoy.getMonth())+1) + '/' + hoy.getFullYear();
  let mes:any=((hoy.getMonth())+1);
  mes=(mes.toString().length==1)?"0"+mes:mes;
  let dia:any=hoy.getDate();
  dia=(dia.toString().length==1)?"0"+dia:dia;
  return hoy.getFullYear()+"-"+mes+"-"+dia
}

export const getFecActual_ddmmyyyy=()=>{
  let hoy = new Date();
  let i=0;
  let fecha = hoy.getDate()+ '/' + ((hoy.getMonth())+1) + '/' + hoy.getFullYear();
  let mes:any=((hoy.getMonth())+1);
  mes=(mes.toString().length==1)?"0"+mes:mes;
  let dia:any=hoy.getDate();
  dia=(dia.toString().length==1)?"0"+dia:dia;
  return dia+"-"+mes+"-"+hoy.getFullYear()
}